import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import {
  FaAward,
  FaBatteryHalf,
  FaChartLine,
  FaChevronLeft,
  FaChevronRight,
  FaPlug,
  FaProjectDiagram,
} from "react-icons/fa";
import heroImg from "../assets/banner4.jpg";
import project1 from "../assets/project1.jpeg";
import project2 from "../assets/project2.jpeg";
import project3 from "../assets/project3.jpeg";
import project4 from "../assets/project4.jpeg";
import project5 from "../assets/project5.jpeg";

const projects = [
  "Battery backup and solar systems with AKIBA Commercial Bank, NMB, Bank of Africa and Malawian Embassy.",
  "Solar system supply, installation and commissioning for five surveillance stations in Mpanda and Katavi.",
  "Electrical and CCTV installations for commercial buildings and over 10 residential houses in Dar es Salaam.",
  "Security system installation at NSSF building in Arusha.",
  "AC maintenance support for multiple clients in the city center.",
  "DC and fuel forklift repair and servicing for multiple clients.",
  "Solar water pump installation projects for various clients.",
];

const systems = {
  offGrid: [
    "Solar home system",
    "Solar water pumping system",
    "Solar battery charging and backup system",
    "Solar power traffic lighting system",
  ],
  onGrid: [
    "Solar home system",
    "Feed in Tariff (FIT)",
    "Grid-supported demand management for stable loads",
  ],
};

const financeItems = [
  "Shareholder-backed capital supported by parallel business operations.",
  "Access to institutional credit facilities through established banking partners.",
  "Sustainable reinvestment of ongoing and completed projects to ensure operational continuity.",
];

const projectImages = [
  { src: project1, alt: "Project installation site 1" },
  { src: project2, alt: "Project installation site 2" },
  { src: project3, alt: "Project installation site 3" },
  { src: project4, alt: "Project installation site 4" },
  { src: project5, alt: "Project installation site 5" },
];

export default function HomeBanner4() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % projectImages.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const goToPrevSlide = () => {
    setActiveSlide((prev) =>
      prev === 0 ? projectImages.length - 1 : prev - 1
    );
  };

  const goToNextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % projectImages.length);
  };

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection py-5 fr-project-wrap">
      <div className="container">
        {/* Hero */}
        <div
          className="fr-feature-hero rounded-4 p-4 p-lg-5 mb-5 text-light"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(10,35,61,.9), rgba(8,62,84,.85)), url(${heroImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <span className="fr-kicker d-inline-block mb-2">
            Projects & Performance
          </span>
          <h2 className="fw-bold mb-3">
            Corporate, Institutional & Individual Delivery Track Record
          </h2>
          <p className="mb-0 opacity-90">
            Proven execution of renewable, electrical, maintenance and protection
            systems across Tanzania.
          </p>
        </div>

        {/* Projects + Testimonial */}
        <div className="row g-4 mb-4">
          <div className="col-lg-7">
            <div className="fr-white-panel h-100 p-4 rounded-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <FaProjectDiagram className="text-primary fs-5" />
                <h5 className="fw-bold mb-0 text-secondary">A snippet of our Projects</h5>
              </div>
              <div className="my-4">
                <div
                  className="position-relative overflow-hidden rounded-4"
                  style={{ height: "360px", backgroundColor: "#0f172a" }}
                >
                  {projectImages.map((image, index) => (
                    <img
                      key={image.alt}
                      src={image.src}
                      alt={image.alt}
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        objectFit: "cover",
                        opacity: activeSlide === index ? 1 : 0,
                        transform:
                          activeSlide === index ? "scale(1)" : "scale(1.04)",
                        transition: "opacity 450ms ease, transform 450ms ease",
                      }}
                    />
                  ))}

                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(0,0,0,.5) 100%)",
                    }}
                  />

                  <button
                    type="button"
                    className="btn btn-light btn-sm position-absolute top-50 start-0 translate-middle-y ms-2 rounded-circle d-inline-flex align-items-center justify-content-center"
                    onClick={goToPrevSlide}
                    aria-label="Previous project image"
                    style={{ width: "34px", height: "34px" }}
                  >
                    <FaChevronLeft />
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle d-inline-flex align-items-center justify-content-center"
                    onClick={goToNextSlide}
                    aria-label="Next project image"
                    style={{ width: "34px", height: "34px" }}
                  >
                    <FaChevronRight />
                  </button>

                  <div className="position-absolute bottom-0 start-0 w-100 pb-3 d-flex justify-content-center gap-2">
                    {projectImages.map((image, index) => (
                      <button
                        key={`dot-${image.alt}`}
                        type="button"
                        aria-label={`Go to project image ${index + 1}`}
                        onClick={() => setActiveSlide(index)}
                        className="border-0 p-0 rounded-pill"
                        style={{
                          width: activeSlide === index ? "24px" : "9px",
                          height: "9px",
                          backgroundColor:
                            activeSlide === index
                              ? "rgba(255,255,255,.95)"
                              : "rgba(255,255,255,.55)",
                          transition: "all 250ms ease",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <ul className="fr-list mb-0">
                {projects.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              
            </div>
          </div>

          <div className="col-lg-5">
            <div className="fr-gradient-panel h-100 p-4 rounded-4 d-flex flex-column justify-content-between">
              <div className="text-muted">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <FaAward className="fs-5 text-primary" />
                  <h5 className="fw-bold mb-0 text-secondary">Client Testimony</h5>
                </div>
                <p className="small opacity-90">
                  Working with DOUBLE F on our solar project was a success from
                  consultation and design to installation and after-sales
                  support.
                </p>
              </div>
              <p className="fw-semibold small mb-0 text-muted">
                Spokesperson, Bank of Africa
              </p>
            </div>
          </div>
        </div>

        {/* Systems + Finance */}
        <div className="row g-4 mb-5">
          <div className="col-lg-4">
            <div className="fr-white-panel h-100 p-4 rounded-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <FaBatteryHalf className="text-primary fs-5" />
                <h6 className="fw-bold mb-0 text-primary">Off-Grid Systems</h6>
              </div>
              <ul className="fr-list mb-0">
                {systems.offGrid.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="fr-white-panel h-100 p-4 rounded-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <FaPlug className="text-primary fs-5" />
                <h6 className="fw-bold mb-0 text-primary">On-Grid Systems</h6>
              </div>
              <ul className="fr-list mb-0">
                {systems.onGrid.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="fr-white-panel h-100 p-4 rounded-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <FaChartLine className="text-primary fs-5" />
                <h6 className="fw-bold mb-0 text-primary">
                  Financial Capacity & Sustainability
                </h6>
              </div>
              <ul className="fr-list mb-0">
                {financeItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Innovation CTA */}
        <div className="fr-innovation-band rounded-4 p-4">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
            <div>
              <h4 className="font-bold mb-1 text-secondary">
                Igniting Africa
              </h4>
              <p className="small text-muted mb-0">
                Solar water pumping and charging systems delivered with trusted
                technical partners.
              </p>
            </div>
            <button
              className="btn btn-secondary d-inline-flex align-items-center gap-2 px-4"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Partner With uS <IoMdArrowDropright size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
